import { render, staticRenderFns } from "./articleModel.vue?vue&type=template&id=7dd4b960&scoped=true"
import script from "./articleModel.vue?vue&type=script&lang=js"
export * from "./articleModel.vue?vue&type=script&lang=js"
import style0 from "./articleModel.vue?vue&type=style&index=0&id=7dd4b960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd4b960",
  null
  
)

export default component.exports